import { Monitor, Moon, Sun } from "lucide-react";
import { useEffect, useState } from "react";
import { cn } from "../cn";
import {
  aplicarTemaRenke,
  escolherTemaRenke,
  temaRenkeSalvo,
  type TemaRenke,
} from "./theme";

const CICLO: readonly TemaRenke[] = ["light", "dark", "system"];

function proximo(atual: TemaRenke): TemaRenke {
  const i = CICLO.indexOf(atual);
  return CICLO[(i + 1) % CICLO.length] ?? "dark";
}

function rotuloAria(tema: TemaRenke): string {
  if (tema === "light") return "Tema claro. Clique para escuro.";
  if (tema === "dark") return "Tema escuro. Clique para sistema.";
  return "Tema do sistema. Clique para claro.";
}

export function ThemeToggle({ className }: { readonly className?: string }) {
  const [tema, definirTema] = useState<TemaRenke>(() => temaRenkeSalvo());

  useEffect(() => {
    aplicarTemaRenke(tema);
  }, [tema]);

  useEffect(() => {
    if (tema !== "system") return;
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const aoMudar = () => aplicarTemaRenke("system");
    mq.addEventListener("change", aoMudar);
    return () => mq.removeEventListener("change", aoMudar);
  }, [tema]);

  const Icone = tema === "light" ? Sun : tema === "dark" ? Moon : Monitor;

  return (
    <>
      <button
        type="button"
        className={cn("rk-theme-toggle", "rk-focusable", className)}
        aria-label={rotuloAria(tema)}
        onClick={() => {
          const novo = proximo(tema);
          escolherTemaRenke(novo);
          definirTema(novo);
        }}
      >
        <Icone size={18} strokeWidth={1.75} aria-hidden />
      </button>
      <span className="sr-only" aria-live="polite">
        Tema: {tema}
      </span>
    </>
  );
}
